export const spacebarPanState = {
    held: false,
    clickOrigin: null as { x: number; y: number } | null,
};
